module.exports = __webpack_public_path__ + "img/qrcode1.f8351343.jpg";